module.exports = __webpack_public_path__ + "static/media/Ain_ghazal_icon_200px.b55a5869.png";